import { format, getYear } from 'date-fns';
import { useNavigation, useDayPicker } from 'react-day-picker';

import MonthChangeButton from './MonthChangeButton';

const DayPickerHeader = () => {
  const { goToMonth, nextMonth, previousMonth, currentMonth } = useNavigation();
  const { locale } = useDayPicker();

  const increaseMonth = () => {
    if (nextMonth) goToMonth(nextMonth);
  };

  const decreaseMonth = () => {
    if (previousMonth) goToMonth(previousMonth);
  };

  const currentYear = getYear(currentMonth);

  return (
    <div className="mb-2 flex grid-cols-4 items-center justify-between">
      <MonthChangeButton onClick={decreaseMonth} />
      <div className="col-start-1 flex space-x-1 text-sm font-medium cursor-default">
        <span className="font-medium">{format(currentMonth, 'LLLL', { locale })}</span>
        <span className="font-medium">{currentYear}</span>
      </div>
      <MonthChangeButton onClick={increaseMonth} isIncrease />
    </div>
  );
};

export default DayPickerHeader;
